import React from "react"
import Navbar from "../../../Common/Navbar"
import Footer from "../../../Common/Footer"
import Sidebar from "../../../Sidebar/Sidebar"
import TestPreviewComp from "./Component/TestPreviewComp"


const TestPreview =()=>{
    return(
        <>
        <Navbar />
        <div className="d-flex mainContentArea">
            <Sidebar />
            <TestPreviewComp />
        </div>
        <Footer />
        </>
    )
}

export default TestPreview